// BOT-1697: copy and checks for the three limited objects. The server is the
// source of truth (422 plan_limit); these keep the UI honest before the click.

const NOUNS = { stores: 'stores', fulfillment_methods: 'fulfillment methods', smart_lists: 'smart lists' }

export const limitReached = (limit, count) => limit !== null && limit !== undefined && count >= limit

export function limitMessage(noun, limit) {
  if (limit === 0) return `Your plan does not include ${noun}. Contact support to add them.`
  const word = limit === 1 ? noun.replace(/s$/, '') : noun
  return `Your plan includes ${limit} ${word}. Contact support to add more.`
}

// A .catch handler: toasts a plan limit refusal and resolves undefined; any other
// error is rethrown, or shown as `fallback` when one is given.
export const toastPlanLimit = (showToast, fallback) => error => {
  const message = planLimitError(error) || fallback
  if (!message) throw error
  showToast(message, { type: 'error' })
}

export function planLimitError(error) {
  const data = error?.response?.data
  if (error?.response?.status !== 422 || data?.error !== 'plan_limit') return null
  return limitMessage(NOUNS[data.feature] || data.feature, Number(data.limit))
}
